
define('text!meeting-modal/time-selector/calendar-plugins/calendar-plugins.html',[],function () { return '';});

